import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import CSSTransition from 'react-transition-group/CSSTransition';

import CheckboxInput from '../input/CheckboxInput';

import Storage from '../../helpers/Storage.js';

import '../../sass/components/common/VenuesDropdown.scss';

const mapStoreToProps = (store) => {
  return {
    user: store.data.user,
    venues: store.data.venues || [],
  }
};

class VenuesDropdown extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      overlayHidden: true,
      open: false,
      top: 0,
      selected: this.getSelectedVenues(props),
    };
    this.buttonElem = null;
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.venues !== this.props.venues) {
      this.setState({selected: this.getSelectedVenues(this.props)});
    }
  }

  getSelectedVenues = (props) => {
    const { user, venues = [] } = props;
    const ids = (user.venues || []).map(i => i.id);
    return venues.filter(i => ids.includes(i));
  }

  onApply = () => {
    Storage.setData('venues', this.state.selected);
    this.setState({open: false});
  }

  renderOverlay = () => {
    return (
      <CSSTransition
        in={this.state.open}
        timeout={350}
        classNames='fade'
        onEnter={() => this.setState({overlayHidden: false})}
        onExited={() => this.setState({overlayHidden: true})}
      >
        <div
          className={classnames({
            'popupOverlay': true,
            'hidden': !this.state.open && this.state.overlayHidden,
          })}
          onClick={() => this.setState({open: false})}
        />
      </CSSTransition>
    )
  }

  renderItem = (item) => {
    const selected = this.state.selected.includes(item.id);
    return (
      <div key={item.id} className='listItem'>
        <CheckboxInput
          small
          object={selected}
          onChange={() => this.setState({
            selected: selected
              ? this.state.selected.filter(i => i !== item.id)
              : [...this.state.selected, item.id],
          })}
        />
        <label>{item.name}</label>
      </div>
    )
  }

  renderList = () => {
    const windowCenter = this.props.windowCenter;
    const venues = this.props.user.venues || [];
    const allSelected = venues.reduce(
      (res, cur) => res && this.state.selected.includes(cur.id)
    , true);
    return (
      <div
        className={classnames({
          'list': true,
          'hidden': !this.state.open,
          'right': this.props.anchorRight,
          'expandTop': this.props.expandTop,
          'windowCenter': windowCenter,
        })}
        style={{top: windowCenter ? null : this.state.top}}
      >
        {venues.map(this.renderItem)}
        <div className='listItem'>
          <CheckboxInput
            small
            object={allSelected}
            onChange={() => this.setState({
              selected: allSelected ? [] : venues.map(i => i.id),
            })}
          />
          <label>All outlets</label>
        </div>
        <button onClick={this.onApply}>Apply</button>
      </div>
    )
  }

  render = () => {
    return (
      <div className='venuesDropdown'>
        <div
          className='buttonElement'
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            this.setState({
              open: !this.state.open,
              top: this.buttonElem.getBoundingClientRect().y + 10,
            })
          }}
          ref={elem => this.buttonElem = elem}
        />
        {this.renderOverlay()}
        {this.renderList()}
      </div>
    )
  }

}

export default connect(mapStoreToProps)(VenuesDropdown);
